export default __webpack_public_path__ + "static/media/1.36e3bd43.png";